import { IParagraphReferences, IReferenceQuery } from "Common/Interfaces/Domain/References";
import { baseAPI } from "../BaseAPI";
import { SERVICE_TAG_TYPES } from "../Constants";


const controller = "references";
export const referenceAPI = baseAPI.injectEndpoints({
  endpoints: (build) => ({
    getParagraphReferences: build.query<IParagraphReferences, IReferenceQuery>({
      query: ({ fileId, pageNumber, paragraphs }) => {
        const params = new URLSearchParams({
            paragraphs: paragraphs ?? "",
        });
        
        return {
          url: `${controller}/${fileId}/pages/${pageNumber}?${params.toString()}`,
          method: "GET",
        };
      },
      providesTags: (result) => (result ? [{ type: SERVICE_TAG_TYPES.REFERENCES }] : []),
    }),
  }),
});

export const {useGetParagraphReferencesQuery} = referenceAPI;